import { getApiBaseUrl } from './chatIdentity';

const API_BASE_URL = getApiBaseUrl();
const SHOP_NOTIFICATIONS_BASE = `${API_BASE_URL}/shop-auth/notifications`;

async function readJson(response, fallback) {
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
        const error = new Error(data?.detail || data?.message || fallback);
        error.status = response.status;
        error.data = data;
        throw error;
    }
    return data;
}

export function getShopNotificationsStreamUrl() {
    return `${SHOP_NOTIFICATIONS_BASE}/stream`;
}

export async function fetchShopNotifications() {
    const response = await fetch(SHOP_NOTIFICATIONS_BASE, {
        credentials: 'include',
    });
    const data = await readJson(response, 'Could not load notifications.');
    return {
        notifications: Array.isArray(data?.notifications) ? data.notifications : [],
        unreadCount: Number(data?.unread_count || 0),
    };
}

export async function markShopNotificationRead(notificationId) {
    if (notificationId == null) return false;
    const response = await fetch(`${SHOP_NOTIFICATIONS_BASE}/${encodeURIComponent(notificationId)}/read`, {
        method: 'POST',
        credentials: 'include',
    });
    await readJson(response, 'Could not mark notification read.');
    return true;
}

export async function markAllShopNotificationsRead() {
    const response = await fetch(`${SHOP_NOTIFICATIONS_BASE}/read-all`, {
        method: 'POST',
        credentials: 'include',
    });
    await readJson(response, 'Could not mark notifications read.');
    return true;
}

export async function dismissShopNotification(notificationId) {
    if (notificationId == null) return false;
    const response = await fetch(`${SHOP_NOTIFICATIONS_BASE}/${encodeURIComponent(notificationId)}/dismiss`, {
        method: 'POST',
        credentials: 'include',
    });
    await readJson(response, 'Could not dismiss notification.');
    return true;
}
